import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';

import { EmtGeneratedContentComponent } from './GeneratedContent/EmtGeneratedContent';
import { ContentSkeleton } from './subcomponents/Skeletons';

const HydratedEmtGeneratedContent = withHydrator({
  id: 'emt-generated-content',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder: (<ContentSkeleton />)
}, EmtGeneratedContentComponent);

const DynamicEmtGeneratedContent = withDynamicComponent(HydratedEmtGeneratedContent, { placeholder: <ContentSkeleton /> });
export const EmtGeneratedContent = withErrorBoundary(DynamicEmtGeneratedContent);

EmtGeneratedContent.dataModel = EmtGeneratedContentComponent.dataModel;
EmtGeneratedContent.propTypes = EmtGeneratedContentComponent.propTypes;